export default "__VITE_ASSET__LElnViEQ__"